import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import isEmpty from "lodash/isEmpty";
import SearchMyBooking from "app/pages/Account/SearchMyBooking/SearchMyBooking";
import { bindActionCreators } from "redux";
import { fetchSearchMyBooking } from "app/pages/Account/SearchMyBooking/searchMyBookingActionCreators";
import { useCallback, useContext, useState } from "react";
import PropTypes from "prop-types";
import AppGlobalsContext from "app/AppGlobalsContext";
import { updateEmail } from "app/reducers/emailActionCreators";
import { HTTP_STATUS_CODES } from "app/constants";
import { isWhiteLabel } from "app/reducers/brandSelector";

const searchBookingErrorGenerate = status =>
	({
		[HTTP_STATUS_CODES.NOT_FOUND]: "error.booking.not.found.error",
		[HTTP_STATUS_CODES.TOO_MANY_REQUEST]: "error.booking.too.many.request.error",
	}[status] || "error.generic");

const SearchMyBookingContainer = ({
	fetchSearchMyBooking = () => {},
	updateEmail = () => {},
	isWhiteLabel,
}) => {
	const [myBookingError, setMyBookingError] = useState();
	const { brand } = useContext(AppGlobalsContext);
	const navigate = useNavigate();

	const handleFormSuccess = useCallback(
		(bookingReference, email) => {
			fetchSearchMyBooking({ bookingReference, email, brand }).then(res => {
				if (res.status === 200 && !isEmpty(res?.data?.booking)) {
					setMyBookingError(null);
					updateEmail(email);
					navigate(`/account/mybookings/${bookingReference}`, { replace: true });
				} else {
					setMyBookingError(searchBookingErrorGenerate(res.status));
				}
			});
		},
		[brand]
	);

	return (
		<SearchMyBooking
			onFormSuccess={handleFormSuccess}
			myBookingError={myBookingError}
			setMyBookingError={setMyBookingError}
			isWhiteLabel={isWhiteLabel}
		/>
	);
};

const mapStateToProps = state => {
	return {
		isWhiteLabel: isWhiteLabel(state),
	};
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ fetchSearchMyBooking, updateEmail }, dispatch);

SearchMyBookingContainer.propTypes = {
	fetchSearchMyBooking: PropTypes.func,
	isWhiteLabel: PropTypes.bool,
	updateEmail: PropTypes.func,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SearchMyBookingContainer);
